import { SEND_AGAIN_SMS_CODE_STATUSES, SMS_CODE_STATUSES } from '../reducers/contract-sign-reducer'
import { ISetVerificationCodeInputValueAction } from '../types'

export const SUBMIT_CODE_AGAIN = "SUBMIT_CODE_AGAIN";
export const CODE_SUBMITED = "CODE_SUBMITED";
export const SMS_CODE_VALIDATION_ERROR = "SMS_CODE_VALIDATION_ERROR";
export const SEND_SMS_CODE_AGAIN_VALIDATION_ERROR = "SEND_SMS_CODE_AGAIN_VALIDATION_ERROR";
export const SET_AGREEMENT_FILE_NAME = "SET_AGREEMENT_FILE_NAME";
export const SET_VERIFICATION_CODE_INPUT_VALUE = "SET_VERIFICATION_CODE_INPUT_VALUE";
export const RESET_VERIFICATION_CODE_FORM = "RESET_VERIFICATION_CODE_FORM";
export const SET_CURRENT_FULL_SMS_CODE = "SET_CURRENT_FULL_SMS_CODE";
export const SET_CURRENT_CLIENT_PESEL_RESERVED_ERROR_TEXT = "SET_CURRENT_CLIENT_PESEL_RESERVED_ERROR_TEXT";


export interface CodeSubmitedAction {
  type: typeof CODE_SUBMITED;
  payload: boolean;
}

export interface SubmitCodeAgainAction {
  type: typeof SUBMIT_CODE_AGAIN;
  payload: boolean;
}
export interface SetSmsCodeValidationErrorAction {
  type: typeof SMS_CODE_VALIDATION_ERROR;
  payload: SMS_CODE_STATUSES;
}
export interface SetSendAgainSmsCodeValidationErrorAction {
  type: typeof SEND_SMS_CODE_AGAIN_VALIDATION_ERROR;
  payload: SEND_AGAIN_SMS_CODE_STATUSES;
}
export interface SetAgreementFileName {
  type: typeof SET_AGREEMENT_FILE_NAME;
  payload: string
}
export interface SetVerificationCodeInputValueAction {
  type: typeof SET_VERIFICATION_CODE_INPUT_VALUE;
  payload: ISetVerificationCodeInputValueAction
}
export interface ResetVerificationCodeFormAction {
  type: typeof RESET_VERIFICATION_CODE_FORM;
}
export interface SetCurrentSmsCodeAction {
  type: typeof SET_CURRENT_FULL_SMS_CODE;
  payload: string;
}
export interface SetCurrentClientPeselReservedErrorTextAction {
  type: typeof SET_CURRENT_CLIENT_PESEL_RESERVED_ERROR_TEXT;
  payload: string;
}

export type SmsCodeActions =
  | CodeSubmitedAction
  | SubmitCodeAgainAction
  | SetSmsCodeValidationErrorAction
  | SetAgreementFileName
  | SetVerificationCodeInputValueAction
  | ResetVerificationCodeFormAction
  | SetSendAgainSmsCodeValidationErrorAction
  | SetCurrentSmsCodeAction
  | SetCurrentClientPeselReservedErrorTextAction
